module.exports = __webpack_public_path__ + "media/MRI4B.e17a5003.mp3";